import { PartnerInfo } from '../types';

export const fetchPartnerInfo = async (
  token: string
): Promise<PartnerInfo> => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/partner/info`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  return response.json();
};

export const fetchAllPartners = async (
  token: string
): Promise<PartnerInfo[]> => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/partner/all`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error('Failed to fetch partners');
    }

    return response.json();
  } catch (error) {
    console.error('Error fetching partners:', error);
    throw error;
  }
};

export const updatePartnerInfo = async (
  token: string,
  partnerData: Partial<PartnerInfo>
): Promise<PartnerInfo> => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/partner/info`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(partnerData),
    }
  );

  if (!response.ok) {
    throw new Error('Failed to update partner information');
  }

  return response.json();
};

export const deletePartner = async (
  token: string,
  id: string
): Promise<void> => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/partner/${id}`,
    {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error('Failed to delete partner');
  }
};
